import {
    addDoc,
    getDocs,
    collection,
    doc,
    updateDoc,
    getCountFromServer,
    query
} from 'firebase/firestore'
import { db } from '../firebase'
import User from './user';
export default class Notification {
    constructor() {
        this.KEY = 'InternalNotification'
    }
    async allNotifications() {
        let data = []
        try {
            const querySnapshot = await getDocs(collection(db, this.KEY));

            querySnapshot.forEach((doc) => {
                data.push({ ...doc.data(), id: doc.id })
            });
            return data
        } catch (error) {
            console.error(error);
            return []
        }
    }
    async addNotification(params) {
        const { role, title, body } = params
        const userFunc = role === '' ? 'allClients' : 'allServiceProviders'
        try {
            const tokens = await (await new User()[userFunc]()).map(el => el.token)
            if (!tokens || !tokens.length) {
                console.log('No tokens')
                return;
            }
            const message = {
                to: tokens,
                title,
                body
            }
            fetch('https://coatedlens-api.onrender.com/send/message', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${process.env.REACT_APP_ACCESS_TOKEN}`,


                },
                body: JSON.stringify(message),
            }).then(() => console.log('Successful')).catch(e => console.error(e))
            try {
                if (params.id) {
                    const { id, ...prms } = params
                    const docRef = doc(db, this.KEY, id)
                    return await updateDoc(docRef, prms)
                }
                const coll = collection(db, this.KEY);
                const snapshot = await (await getCountFromServer(query(coll))).data().count;
                return await (await addDoc(collection(db, this.KEY), { ...params, id: snapshot })).id
            } catch (error) {
                console.error(error, params);
            }
        }
        catch (e) {
            console.error(e, params);
        }

    }
}